<template>
  <!--begin::Property Listing-->
  <div class="property-template">
    <PageHeaderCount moduleType="addons" :dataLoading="dataLoading" :statusList="statusList" allkey="all_properties"
      countkey="add_one_status_count"></PageHeaderCount>
    <ListingTemplate :customClass="'property-listing'" v-if="getPermission('property:view')">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 my-auto">
                <h1 class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text">
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('property:update')">
                  <v-menu content-class="custom-menu-list" bottom offset-y transition="slide-y-transition"
                    :close-on-click="true">
                    <template v-slot:activator="{ on, $attrs }">
                      <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text" v-bind="$attrs" v-on="on">
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(more, index) in propertyMoreActions">
                        <v-list-item link v-on:click="updateMoreAction(more.action)" :key="index">
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              more.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title class="font-weight-500 font-size-14">{{ more.title }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text" v-on:click="clearSelections">
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0 mxw-200 my-auto">
                <h1 class="form-title d-flex margin-auto">
                  <v-select :disabled="dataLoading" :items="statusList" v-model="status" hide-details item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter" item-text="text" item-value="value">
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip :color="item.color">
                          <template v-if="item.value == 'all'">
                            {{ item.all_properties }}
                          </template>
                          <template v-else>{{
                            item.add_one_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto all-project-btn-right">
                <template v-if="getPermission('property:create')">
                  <v-btn depressed :disabled="dataLoading" class="mx-2 custom-bold-button custom-btn-color white--text"
                    @click="ViewCreateAddon = !ViewCreateAddon">
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text" v-on:click="searchDialog = true">
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-menu v-if="false" content-class="custom-menu-list" offset-y left>
                  <template v-slot:activator="{ on, $attrs }">
                    <v-btn depressed :disabled="dataLoading" class="mx-2 custom-bold-button"
                      v-on:click="exportQuotation" color="cyan white--text">
                      <v-icon dark left>mdi-database-export</v-icon> Export
                    </v-btn>
                    <v-btn depressed :disabled="dataLoading" class="mx-2 custom-bold-button"
                      v-on:click="importDialog = true" color="cyan white--text">
                      <v-icon dark left>mdi-database-import</v-icon> Import
                    </v-btn>
                    <!-- <v-btn
                      :disabled="dataLoading || exportLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="$attrs"
                      v-on="on"
                      :loading="exportLoading"
                    >
                      <v-icon dark>mdi-menu</v-icon>
                    </v-btn> -->
                  </template>
                  <v-list>
                    <template v-for="(item, index) in moreActions">
                      <v-list-item :key="index" link v-on:click="moreAction(item.action, item.sort)">
                        <v-list-item-title>
                          <v-icon v-if="item.icon" left color="cyan">{{
                            item.icon
                          }}</v-icon>
                          {{ item.title }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
                <v-menu max-height="400" max-width="250" offset-y left :close-on-content-click="false"
                  content-class="white-background">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed :disabled="dataLoading" class="mx-2 custom-bold-button" color="cyan white--text"
                      v-bind="attrs" v-on="on">
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>

                  <draggable tag="ul" v-model="defaultColDefs" class="draggable-group" handle=".draggable-drag-icon"
                    v-on:change="updateVisible()">
                    <template v-for="cols in defaultColDefs">
                      <li class="draggable-group-item" :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0">
                        <v-checkbox dense v-model="defaultColShow" v-bind:value="cols.field" :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading" color="cyan" hide-details
                          v-on:change="updateVisible()" class="mt-0 mb-0"></v-checkbox>
                        <v-icon class="draggable-drag-icon" right color="cyan">mdi-drag</v-icon>
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <v-menu offset-y left v-if="false">
                  <template v-slot:activator="{ on: menu, $attrs }">
                    <v-tooltip top content-class="custom-top-tooltip">
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn depressed :disabled="dataLoading" class="ml-2 custom-bold-button"
                          color="cyan white--text" v-bind="$attrs" v-on="{ ...tooltip, ...menu }">
                          {{ entityObject.name }}
                        </v-btn>
                      </template>
                      <span>Entity</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in entityList" :key="index" link v-on:click="updateEntity(item)">
                      <v-list-item-title class="font-weight-600">{{
                        item.name
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <PageTips v-if="false" module="property"></PageTips>
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria v-if="searchEnabled" pageModule="addons" :basicSearchFields="['barcode', 'Addon Name']"
          :allowedSearchFields="searchableArray"></ListingSearchCriteria>
        <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative">
          <ListingTable :columnCount="columnLength()" :dataLoading="dataLoading" :rowData="rowData">
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th v-if="cols.visible" :key="cols.id" class="simple-table-th" :class="{
                      'checkbox-width-limit': cols.checkbox,
                      'pointer-events-none': lodash.isEmpty(rowData),
                    }">
                      <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                        <v-checkbox dense :disabled="dataLoading" v-model="selectedAll" color="cyan" class="hide-margin"
                          hide-details></v-checkbox>
                      </template>
                      <template v-else>
                        <div v-if="cols.sortable" class="simple-table-text sortable" v-on:click="
                          !dataLoading
                            ? updateSorting({
                              field: cols.field,
                              sort: cols.sort,
                            })
                            : 'javascript:void(0)'
                          ">
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon class="simple-table-sort" v-if="cols.sort == 'asc'" small right
                            color="cyan">mdi-sort-ascending</v-icon>
                          <v-icon class="simple-table-sort" v-if="cols.sort == 'desc'" small right
                            color="cyan">mdi-sort-descending</v-icon>
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!lodash.isEmpty(rowData)">
                  <tr v-for="(data, index) in rowData" :key="index" link class="property-listing-row"
                    :class="{ 'table-in-active-row': !data.status }">
                    <template v-for="cols in customThead">
                      <td v-if="cols.visible" :key="cols.id" :class="{
                        'simple-table-td': !cols.checkbox,
                        'checkbox-width-limit': cols.checkbox,
                      }" v-on:click="
                        Number(cols.checkbox) == 0
                          ? rowClicked(data)
                          : 'javascript:void(0)'
                        ">
                        <template v-if="cols.checkbox && Number(cols.checkbox) == 1">
                          <v-checkbox dense v-model="selectedRows" v-bind:value="data.id" color="cyan"
                            class="hide-margin" hide-details></v-checkbox>
                        </template>

                        <template v-else-if="cols.field == 'barcode'">
                          <Barcode :barcode="data[cols.field]"></Barcode>
                        </template>
                        <template v-else-if="cols.field == 'price'">
                          <div class="property-listing-customer">
                            <p>
                              <template v-if="data?.price">
                                <b> $ </b>
                                {{ data?.price }}
                              </template>
                              <em v-else class="text-muted"> no price</em>
                              <br />
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'tax'">
                          <div class="property-listing-customer">
                            <p>
                              <template v-if="data?.tax">
                                {{ data?.tax }}
                              </template>
                              <em v-else class="text-muted"> no tax</em>
                              <br />
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'status'">
                          <div>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip label dense v-bind="attrs" v-on="on" text-color="white"
                                  style="height: 20px !important" :color="data.status === '1' ? 'green' : 'red'">
                                  <template v-if="data.status === '1'">Active</template>
                                  <template v-else>In-Active</template>
                                </v-chip>
                              </template>
                              <span v-if="data.status === '1'">Active </span>
                              <span v-else>In-Active</span>
                            </v-tooltip>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'quantity'">
                          <div class="property-listing-customer">
                            <p>
                              <template v-if="data?.quantity">
                                {{ data?.quantity }}
                              </template>
                              <em v-else class="text-muted"> no quantity</em>
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'duration'">
                          <div class="property-listing-customer">
                            <p>
                              <template v-if="data?.duration">
                                {{ data?.duration }} {{ data?.duration_type }}
                              </template>
                              <em v-else class="text-muted"> no duration</em>
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity v-if="!lodash.isEmpty(data.added_by)" :data="data">
                            <template v-slot:display_name>
                              {{ data.added_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              <template v-if="getDateCountAll(data.added_at)">{{
                                data.added_at
                              }}</template>
                              <template v-else>{{ data.added_at }}</template>
                            </template>
                            <template v-slot:format_date_time>
                              {{ data.added_at }}
                              {{ data.added_at }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td colspan="12" class="py-4">
                    <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                      <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                      Uhh... There are no add on at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter :dataLoading="dataLoading" :showingFrom="showingFrom" :showingTo="showingTo"
          :totalRows="totalRows" :currentPage="currentPage" :totalPages="totalPages"></ListingFooter>
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter Add-On</template>
          <template v-slot:body>
            <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative">
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="
                      field != 'tax' &&
                      field != 'dates' &&
                      field != 'name'
                    ">
                      <v-text-field v-model.trim="listingSearch[field]" dense filled hide-details solo flat clearable
                        @keydown.enter="filterRows" :placeholder="getFilterLabel(field, 'addons')"
                        color="cyan"></v-text-field>
                      <!-- <v-text-field v-model.trim="listingSearch[field]" dense filled hide-details solo flat clearable
                        @keydown.enter="filterRows" :placeholder="getFilterLabel(field, 'addons')"
                        color="cyan"></v-text-field> -->
                    </v-col>
                    <v-col md="6" :key="index" v-if="field === 'name'">
                      <v-text-field v-model.trim="listingSearch[field]" dense filled hide-details solo flat clearable
                        @keydown.enter="filterRows" :placeholder="getFilterLabel(field, 'addons')"
                        color="cyan"></v-text-field>


                      <!-- <v-select :items="durationTypes" v-model.trim="listingSearch[field]" dense filled
                        item-text="value" item-value="value" item-color="cyan" :placeholder="field" solo flat clearable
                        color="cyan"></v-select> -->
                    </v-col>
                    <!-- <v-col md="6" :key="index" v-if="field === 'tax'">
                      <v-select :items="taxTypes" v-model.trim="listingSearch[field]" dense filled item-text="value"
                        item-value="value" item-color="cyan" :placeholder="field" solo flat clearable
                        color="cyan"></v-select>
                    </v-col> -->
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text" v-on:click="filterRows">
              Filter
            </v-btn>
            <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false">
              Close
            </v-btn>
          </template>
        </Dialog>
        <ImportTemplate :dialog="importDialog" sample-url="public/import-samples/PropertySample.xlsx"
          api-url="address/import" title="Import addons" v-on:close="importDialog = false"></ImportTemplate>
        <!-- <template v-if="entityDialog">
          <EntityDialog :entity-dialog="entityDialog" v-on:closeDialog="entityDialog = false"
            v-on:resetAll="entityDialog = false" v-on:selectEntity="selectEntity"></EntityDialog>
        </template> -->
        <!-- <template v-if="entity && customerDialog">
          <CustomerDialog :entity="Number(entity)" :customerDialog="customerDialog"
            v-on:closeDialog="customerDialog = false" v-on:resetAll="customerDialog = false"
            v-on:selecttransformer="selecttransformer"></CustomerDialog>
        </template> -->
        <template v-if="entity && ViewCreateAddon">
          <CreateAddons :entity="Number(entity)" v-on:closeDialog="ViewCreateAddon = false"
            :ViewCreateAddon="ViewCreateAddon" @closeDialog="closeDialogBatch" @afterSubmit="goToDetail">
          </CreateAddons>
        </template>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Property Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { DOWNLOAD } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CreateAddons from "@/view/pages/add-ons/Create-Addons.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
// import addonsList from "@/view/pages/oil-sample/Oil-Sample-Tab.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
// import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
// import TransformerDialog from "@/view/pages/partials/Select-Transformer.vue";
import { saveAs } from "file-saver";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
// import EntityDialog from "@/view/pages/partials/Select-Entity.vue";
import ImportTemplate from "@/view/pages/partials/Import-Template.vue";
import JwtService from "@/core/services/jwt.service";
import { ServiceFormEventBus } from "@/core/lib/service.form.lib";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";

import moment from "moment-timezone";
export default {
  props: {
    status: {
      type: String,
      default: "new",
    },
  },
  mixins: [CommonMixin, ListingMixin],
  name: "property-list",
  data() {
    return {
      // customerDialog: false,
      // TransformerDialog: false,
      selecttransformer: false,
      ViewCreateAddon: false,
      exportLoading: false,
      pageModule: "property-listing",
      routeAPI: "addons",
      routeName: "addons",
      routeDetailName: "addons.detail",
      statusList: [],
      customThead: [],
      salaryTypes: [],
      importDialog: false,
      moreActions: [
        {
          title: "Import addons(s)",
          action: "import_items",
          divider: true,
          icon: "mdi-database-import",
        },
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      propertyMoreActions: [
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          action: "inactive",
        },
      ],
      entity: 1,
      entityDialog: false,
    };
  },
  components: {
    draggable,
    PageTips,
    // EntityDialog,
    CreateAddons,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    ImportTemplate,
    PageHeaderCount,
  },
  methods: {
    closeDialogBatch() {
      this.ViewCreateAddon = false;
    },
    goToDetail(id) {
      this.$router.push(
        this.getDefaultRoute("addons.detail", {
          params: { id: id },
        })
      );
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    selectEntity(param) {
      this.entity = Number(param);
      this.entityDialog = false;
      this.$nextTick(() => {
        // this.TransformerDialog = true;
      });
    },
    selectTransformer(transformer) {
      if (Number(transformer) > 0) {
        this.$router.push(
          this.getDefaultRoute("addons.create", {
            query: { transformer },
          })
        );
      }
    },
    exportQuotation() {
      //console.log(row,"rowhhh");
      //console.log(this.searchableArray,"searchableArray");

      let downloadURL = process.env.VUE_APP_API_URL + "property/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      //downloadURL.searchParams.append("search", this.queryParams.search);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      this.lodash.map(this.listingSearch, function (row, index) {
        // console.log(index, "indexdd")

        if (index == "dates") {
          if (row && row[0]) {
            downloadURL.searchParams.append("dates[0]", row[0]);
          }
          if (row && row[1]) {
            downloadURL.searchParams.append("dates[1]", row[1]);
          }
        } else {
          downloadURL.searchParams.append(index, row);
        }

        //  downloadURL.searchParams.append(index, row);
      });
      window.open(downloadURL, "_blank");
    },
    // getPropertyAddress(data) {
    //   let result = [];
    //   if (this.lodash.isEmpty(data) === false) {
    //     if (data.unit_no) {
    //       result.push(data.unit_no);
    //     }
    //     if (data.street_1) {
    //       result.push(data.street_1);
    //     }
    //     if (data.street_2) {
    //       result.push(data.street_2);
    //     }
    //     if (data.zip_code) {
    //       result.push(data.zip_code);
    //     }
    //   }
    //   return result.join(", ");
    // },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          _this.importDialog = true;
          break;
        case "export_items":
          _this.bulkPropertyExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("property");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    updateMoreAction(param) {
      const _this = this;
      switch (param) {
        case "active":
          _this.bulkUpdateaddons({
            properties: _this.selectedRows,
            status: 1,
          });
          break;
        case "inactive":
          _this.bulkUpdateaddons({
            properties: _this.selectedRows,
            status: 0,
          });
          break;
      }
    },
  },
  bulkPropertyExport() {
    const _this = this;
    let fileName = new Date();
    _this.exportLoading = true;
    _this.$store
      .dispatch(DOWNLOAD, {
        url: "property/export",
      })
      .then(({ data }) => {
        saveAs(data, "property-export-" + fileName.getTime() + ".xlsx");
      })
      .catch((error) => {
        _this.logError(error);
      })
      .finally(() => {
        _this.exportLoading = false;
      });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Add On" }]);
    ServiceFormEventBus.$on("reload:staffdata", () => {
      this.getRows();
    });
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    /*  _this.applyColState(); */

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
